import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS } from '../constants/api';
import {} from '../constants';
import '../css/modal.css';
import { notification } from 'antd';
import '../css/autocomplete.css';
import UpdateModal from './UpdateModal';
import { decodeToken } from '../utils/TokenUtils';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const BlankHorizontalForm = ({
  link,
  inputs,
  setInputs,
  values,
  setValues,

  setData,
  setReportHeader,
  setReportFooter,
  token,
  setIsModalOpen,
  handleUploadToServer = () => {},
  handleFileUploadChange = () => {},
  uploadLoading = false,
}) => {
  // console.log('link:', link);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userId = decodeToken(token, 'id');
  const userLevel = decodeToken(token, 'userLevel');
  const intervalRef = useRef(null); // To keep track of the interval
  
  const [suggestions, setSuggestions] = useState([]);

  const [queries, setQueries] = useState({});

  const [loading, setLoading] = useState(false);
  const [counter, setCounter] = useState(1); // Start counter from 1

  const [isModalUpdateOpen, setIsModalUpdateOpen] = useState(false);
  const [updateId, setUpdateId] = useState(null);
  const [updateTable, setUpdateTable] = useState(null);
  const [updateRouteId, setUpdateRouteId] = useState(null);

  const openUpdateModal = (id, table, routeId) => {
    if (userLevel === 'developer') {
      setUpdateId(id);
      setUpdateTable(table);
      setUpdateRouteId(routeId);

      // setUpdateTable()
      setIsModalUpdateOpen(true);
    }
  };
  const closeUpdateModal = () => {
    setUpdateId(null);
    setIsModalUpdateOpen(false);
  };

  // console.log('userLevel: ', userLevel, 'Token:', token);
  //console.log('inputs: ', inputs);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    //console.log(name, value, type, checked );
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    // If month or year changes, fetch from and to dates
    if ((name === 'month' || name === 'year') && values.month && values.year) {
      let m = values.month;
      let y = values.year;

      if (name === 'month') {
        m = value;
      }
      if (name === 'year') {
        y = value;
      }

      fetchFromToDates(m, y, 'from', 'to');
    }
  };

  //console.log('inputs:', inputs);

  const handleLoadDropdownChange = async (e, input) => {
    const { name, value, type, checked } = e.target;
    const inputId = input.id;
    const inputName = input.name;
    const loadInputName = input.load_input_name;
    // console.log('input:', input);

    // check if load-dropdowns does not have load-input-name and stop loading
    if (!input.load_input_name || !input.load_input_name.trim()) {
      setLoading(false);
      return;
    }
    //console.log('input:', input);

    // console.log(name, value, type, checked);
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    try {
      setLoading(true);
      const url = `${API_URL}/${ENDPOINTS.SYS}/load-dropdown/${inputId}/${value}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });

      // console.log('url:', url, 'response:', response.data);
      //setSuggestions(response.data); // Update suggestions from server response
      // console.log('input:', input);
      setInputs((prevInputs) =>
        prevInputs.map(
          (input) =>
            input.name === loadInputName
              ? { ...input, dynamic_options: response.data } // Update the dynamic_options
              : input // Keep other inputs unchanged
        )
      );
    } catch (error) {
      console.error('Error fetching suggestions:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAutocompleteChange = (e, inputId) => {
    const { name, value, type, checked } = e.target;

    setQueries((prev) => ({ ...prev, [inputId]: value }));

    //setInputId(inputId);
    // setQuery(value);

    fetchSuggestions(value, inputId);
  };

  // Function to fetch suggestions from the server
  const fetchSuggestions = async (query, inputId) => {
    if (!query) {
      setSuggestions((prev) => ({ ...prev, [inputId]: [] }));
      return;
    }
    try {
      setLoading(true);
      const url = `${API_URL}/${ENDPOINTS.SYS}/autocomplete/${inputId}?query=${query}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });

      // console.log('url:', url, 'response:', response.data);
      // setSuggestions(response.data); // Update suggestions from server response
      setSuggestions((prev) => ({ ...prev, [inputId]: response.data }));
    } catch (error) {
      console.error('Error fetching suggestions:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSetClickedValue = (input, suggestion) => {
    //console.log(name, value, type, checked );
    //console.log('input:', input);
    setValues((prevValues) => ({
      ...prevValues,
      [input.name]: suggestion.id,
    }));
    // setQuery(suggestion.name);

    setQueries((prev) => ({ ...prev, [input.id]: suggestion.name }));
    setSuggestions((prev) => ({ ...prev, [input.id]: [] }));
  };

  // Function to fetch from and to dates based on selected month and year
  const fetchFromToDates = async (month, year, fromInputName, toInputName) => {
    try {
      const url = `${API_URL}/${ENDPOINTS.SYS}/get-from-to/${month}/${year}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });
      const data = response.data;
      // console.log('url:', url, 'from-to:', data);
      // Update the form fields with the returned from/to dates
      setValues((prevValues) => ({
        ...prevValues,
        [fromInputName]: data.fromDate,
        [toInputName]: data.toDate,
      }));
    } catch (error) {
      console.error('Error fetching from/to dates:', error);
    }
  };

  // Handle file input changes dynamically
  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0]; // Get the selected file

    setValues((prev) => ({
      ...prev,
      [name]: file, // Dynamically set the file input field by name
    }));
  };

  //console.log('values:', values);

  //console.log('insert route:', `${API_URL}/${ENDPOINTS.SYS}/create/${route}`)

  const fetchData = async () => {
    setLoading(true);
    setCounter(1); // Reset counter
    // Clear the previous interval (if it exists)

    // Start a new interval
    intervalRef.current = setInterval(() => {
      setCounter((prev) => prev + 1); // Increment counter each second
      console.log('Interval running', counter); // Debugging: check if counter updates
    }, 1000);

    setData([]);

    setReportHeader([]);
    setReportFooter([]);
    //console.log('linsk:', link);
    const startTime = Date.now(); // Start time for the request
    link.route = link?.route?.replace('/', '%2F'); //encode / forword for some routes
    try {
      var reportUrl = '';
      if (link.sql_query && link.sql_query.trim() !== '') {
        reportUrl = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/${link.route}`;
      } else if (link.api_route !== '' && link.api_route.trim() !== '') {
        reportUrl = `${API_URL}/${link.api_route}`;
      }
      // console.log('report route:', reportUrl, 'values:', values);

      const data2 = new FormData();

      // Append all fields (including files) to FormData
      Object.keys(values).forEach((key) => {
        data2.append(key, values[key]); // Appends both files and text fields dynamically
      });
      try {
        var response;
        if (link.form_type === 'reg-upload-modal') {
          response = await axios.post(reportUrl, data2, {
            headers: {
              'Content-Type': 'multipart/form-data', // Required for FormData
              Authorization: token ? `Bearer ${token}` : '',
            },
          });
        } else {
          response = await axios.post(reportUrl, values, {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          });
        }

        // print console url, request and response

        if (userLevel === 'developer') {
          console.log(
            'url:',
            reportUrl,
            'request:',
            values,
            'reponse:',
            response.data
          );
        }

        // console.log(response);
        if (response.data.message) {
          notification.error({ message: response.data.message });
          setData([]);
          setLoading(false);
          // Clear the previous interval if it exists
          if (intervalRef.current) {
            console.log('Clearing old interval'); // Debugging
            clearInterval(intervalRef.current);
          }
          setReportHeader([]);
          setReportFooter([]);
        } else if (response.data.data.errno) {
          notification.error({ message: response.data.data.sqlMessage });
          setData([]);
          setLoading(false);
          // Clear the previous interval if it exists
          if (intervalRef.current) {
            console.log('Clearing old interval'); // Debugging
            clearInterval(intervalRef.current);
          }
          setReportHeader([]);
          setReportFooter([]);
        } else {
          setLoading(false);

          setData(response.data.data);

          setIsModalOpen(true);

          setReportHeader(response.data.reportHeader);
          setReportFooter(response.data.reportFooter);

          // Clear the previous interval if it exists
          if (intervalRef.current) {
            console.log('Clearing old interval'); // Debugging
            clearInterval(intervalRef.current);
          }
        }

        // onRequestClose(); // Close modal after submission
      } catch (error) {
        alert(`An error occurred -1 ${error.message}`);
        setData([]);
        setLoading(false);
        // Clear the previous interval if it exists
        if (intervalRef.current) {
          console.log('Clearing old interval'); // Debugging
          clearInterval(intervalRef.current);
        }
        setReportHeader([]);
        setReportFooter([]);

        // console.log('error:', error, 'insertUrl:',insertUrl, 'values:', values);
      }
    } catch (error) {
      alert(`An error occurred -2 ${error.message}`);
      // Clear the previous interval if it exists
      if (intervalRef.current) {
        console.log('Clearing old interval'); // Debugging
        clearInterval(intervalRef.current);
      }
      setData([]);
      setReportHeader([]);
      setReportFooter([]);
    }
  };

  //re-fetch data after user submit the form
  const handleSubmit = (e) => {
    e.preventDefault();
    if (button === 'csv-uploader') {
      handleUploadToServer(e);
    } else {
      fetchData();
    }
  };

  const [button, setButton] = useState('');

  const handleCsvUploadChange = (event) => {
    const selectedFile = event.target.files[0];
    setButton('csv-uploader'); // Update the state

    // Call the external handler if provided
    handleFileUploadChange?.(event);
  };

  return (
    <div className="d-flex align-items-start flex-wrap gap-3">
      {inputs && inputs.length > 0 && (
        <form className="d-flex align-items-start flex-wrap gap-3"
          onSubmit={handleSubmit}
          encType="multipart/form-data"
        >
          {inputs.map((input) => {
            const options =
              input.options?.split(',').map((option) => option.trim()) || [];

            return (
              <div className="d-flex flex-column mb-3" key={input.name}>
                {input.type !== 'hidden-user' &&
                  input.type !== 'hidden-branch' &&
                  input.type !== 'hidden' && (
                    <></>
                    //   <label
                    //     htmlFor={input.name}
                    //     className="form-label text-capitalize font-weight-bold"
                    //     onDoubleClick={() =>
                    //       openUpdateModal(input.id, 'ktc_input', 11)
                    //     }
                    //     style={{ cursor: 'pointer' }}
                    //     title={
                    //       userLevel === 'developer'
                    //         ? `Double click to update/edit the ${input.label} element`
                    //         : ''
                    //     }
                    //   >
                    //     {/* {input.label}: */}
                    //     {t(input.label)}:
                    //     {input.is_required !== 0 && (
                    //       <span
                    //         className="text-danger"
                    //         title={`'${input.label}' field is required, please fill it before submitting the form`}
                    //       >
                    //         *
                    //       </span>
                    //     )}
                    //   </label>
                  )}
                {(() => {
                  switch (input.type) {
                    case 'radio':
                      return input.dynamic_options?.map((option, index) => (
                        <div className="form-check" key={index}>
                          <input
                            type="radio"
                            className="form-check-input"
                            id={`${input.name}-${index}`}
                            name={input.name}
                            value={option.value}
                            checked={values[input.name] === option.id}
                            onChange={handleChange}
                          />
                          <label
                            htmlFor={`${input.name}-${index}`}
                            className="form-check-label"
                          >
                            {option.name}
                          </label>
                        </div>
                      ));
                    case 'dropdown':
                      return (
                        <select
                          className="form-select"
                          id={input.name}
                          name={input.name}
                          value={values[input.name]}
                          onChange={handleChange}
                          required={input.is_required}
                        >
                          <option value="%">Select all</option>

                          {input.dynamic_options?.map((option, index) => {
                            // Get the keys of the option object
                            const optionKeys = Object.keys(option);

                            // Access the first and second key values (fallback to default if less than 2 keys exist)
                            const firstValue =
                              option[optionKeys[0]] || 'No Value 1';
                            const secondValue =
                              option[optionKeys[1]] || 'No Value 2';

                            return (
                              <option key={index} value={firstValue}>
                                {secondValue}
                              </option>
                            );
                          })}
                        </select>
                      );
                    case 'group-dropdown':
                      return (
                        <select
                          className="form-select"
                          id={input.name}
                          name={input.name}
                          value={values[input.name]}
                          onChange={handleChange}
                          required={input.is_required}
                        >
                          <option value="%">Select all</option>
                          {input.dynamic_options &&
                            Object.entries(
                              input.dynamic_options.reduce((groups, option) => {
                                // Group options by the 'group' key
                                if (!groups[option.group])
                                  groups[option.group] = [];
                                groups[option.group].push(option);
                                return groups;
                              }, {})
                            ).map(([group, options]) => (
                              <optgroup key={group} label={group}>
                                {options.map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.name}
                                  </option>
                                ))}
                              </optgroup>
                            ))}
                        </select>
                      );

                    case 'load-dropdown':
                      return (
                        <select
                          className="form-select"
                          id={input.name}
                          name={input.name}
                          value={values[input.name]}
                          onChange={(e) => handleLoadDropdownChange(e, input)}
                          required={input.is_required}
                          title={`Load dropdow `}
                        >
                          <option value="%">Select all</option>
                          {input.dynamic_options?.map((option, index) => (
                            <option key={index} value={option.id}>
                              {option.name}
                            </option>
                          ))}
                        </select>
                      );

                    case 'autocomplete':
                      return (
                        <div className="position-relative">
                          <input
                            type="text"
                            className="form-control" // Bootstrap class for styling
                            // value={query}
                            value={queries[input.id] || ''}
                            onChange={(e) =>
                              handleAutocompleteChange(e, input.id)
                            }
                            placeholder="Search..."
                            style={{
                              width: '100%', // Ensure it matches the container width
                            }}
                          />
                          {/* {loading && <div>Loading...</div>} */}
                          {suggestions[input.id]?.length > 0 && (
                            <ul
                              className="list-group position-absolute"
                              style={{
                                margin: 0,
                                top: '100%',
                                width: '100%',
                                zIndex: 1,
                                maxHeight: '200px', // Limit height
                                overflowY: 'auto', // Add vertical scroll
                                border: '1px solid #ccc', // Add border for better visibility
                                borderRadius: '4px',
                                backgroundColor: '#fff',
                              }}
                            >
                              {suggestions[input.id].map(
                                (suggestion, index) => (
                                  <li
                                    className="list-group-item"
                                    key={index}
                                    onClick={() => {
                                      handleSetClickedValue(input, suggestion); // Set clicked suggestion as the query
                                      //   setSuggestions([]); // Clear suggestions after selection
                                    }}
                                    style={{
                                      padding: '8px',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    {suggestion.name}
                                  </li>
                                )
                              )}
                            </ul>
                          )}
                        </div>
                      );

                    case 'enum':
                      return options?.map((option, index) => (
                        <div className="form-check" key={index}>
                          <input
                            type="radio"
                            className="form-check-input"
                            id={`${input.name}-${index}`}
                            name={input.name}
                            value={option}
                            checked={values[input.name] === option}
                            onChange={handleChange}
                          />
                          <label
                            htmlFor={`${input.name}-${index}`}
                            className="form-check-label"
                          >
                            {option}
                          </label>
                        </div>
                      ));
                    case 'enum-dropdown':
                      return (
                        <select
                          className="form-select"
                          id={input.name}
                          name={input.name}
                          value={values[input.name]}
                          onChange={handleChange}
                          required={input.is_required}
                        >
                          <option value="%">Select all</option>
                          {options?.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      );
                    case 'checkbox':
                      return (
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={input.name}
                            name={input.name}
                            value={values[input.name]}
                            checked={values[input.name]}
                            onChange={handleChange}
                          />
                          <label
                            htmlFor={input.name}
                            className="form-check-label"
                          >
                            {input.label}
                          </label>
                        </div>
                      );
                    case 'hidden-user':
                      return (
                        <input
                          type="hidden"
                          id={input.name}
                          name={input.name}
                          value={values[input.name]}
                          required={input.is_required}
                        />
                      );
                    case 'hidden-branch':
                      return (
                        <input
                          type="hidden"
                          id={input.name}
                          name={input.name}
                          value={values[input.name]}
                          required={input.is_required}
                        />
                      );
                    case 'textarea':
                      return (
                        <textarea
                          className="form-control"
                          id={input.name}
                          name={input.name}
                          rows="3"
                          value={values[input.name]}
                          onChange={handleChange}
                          required={input.is_required}
                        ></textarea>
                      );
                    case 'file':
                      return (
                        <input
                          type={input.type}
                          className="form-control"
                          id={input.name}
                          name={input.name}
                          placeholder={input.placeholder}
                          onChange={handleFileChange}
                          required={input.is_required}
                        />
                      );
                    case 'csv-upload':
                      return (
                        <input
                          type="file"
                          className="form-control"
                          id={input.name}
                          name={input.name}
                          placeholder={input.placeholder}
                          onChange={handleCsvUploadChange}
                          required={input.is_required}
                        />
                      );
                    case 'today-date':
                      return (
                        <>
                          <input
                            title="Today date, can't change the date"
                            type={input.type}
                            className="form-control"
                            id={input.name}
                            name={input.name}
                            placeholder={input.placeholder}
                            value={values[input.name]}
                            onChange={handleChange}
                            required={input.is_required}
                            readOnly
                          />
                        </>
                      );
                    default:
                      return (
                        <input
                          type={input.type}
                          className="form-control"
                          id={input.name}
                          name={input.name}
                          placeholder={input.placeholder}
                          value={values[input.name]}
                          onChange={handleChange}
                          required={input.is_required}
                        />
                      );
                  }
                })()}
              </div>
            );
          })}

          <div className="d-flex flex-column mb-3">
            {/* <label
            htmlFor=""
            className="form-label text-capitalize font-weight-bold"
          >
            <span className="text-danger">&nbsp;</span>
          </label> */}
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {uploadLoading || loading
                ? `Loading... ${counter} sec`
                : link?.button}
            </button>
          </div>
         
        </form>
        
      )}
      {API_URL.includes('jaziira') && <button className='btn btn-info' onClick={()=> navigate(`/pos`)}>Make Order</button>}
    </div>
  );
};

export default BlankHorizontalForm;
